<script>
    import Curve1 from "../svg/shapes/curves/Curve1.svelte";
    import { _ } from "svelte-i18n";
</script>

<div class="position-relative mt-n15">
    <div class="shape shape-bottom shape-fluid-x text-dark">
        <Curve1 />
    </div>
</div>

<section id="faqs" class="pt-15 bg-dark">
    <div class="container pt-8 pt-md-11">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="d-flex">
                    <div class="badge badge-lg badge-rounded-circle bg-success">
                        <span>?</span>
                    </div>

                    <div class="ms-5">
                        <h4 class="text-white">
                            {$_("communicate.faq.q1.q")}
                        </h4>
                        <p class="text-muted mb-6 mb-md-8">
                            {$_("communicate.faq.q1.a")}
                        </p>
                    </div>
                </div>

                <div class="d-flex">
                    <div class="badge badge-lg badge-rounded-circle bg-success">
                        <span>?</span>
                    </div>

                    <div class="ms-5">
                        <h4 class="text-white">
                            {$_("communicate.faq.q2.q")}
                            
                        </h4>
                        <p class="text-muted mb-6 mb-md-8">
                            {$_("communicate.faq.q2.a")}
                        </p>
                    </div>
                </div>

                <div class="d-flex">
                    <div class="badge badge-lg badge-rounded-circle bg-success">
                        <span>?</span>
                    </div>

                    <div class="ms-5">
                        <h4 class="text-white">
                            {$_("communicate.faq.q5.q")}
                        </h4>

                        <p class="text-muted mb-6 mb-md-0">
                            {$_("communicate.faq.q5.a")}
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="d-flex">
                    <div class="badge badge-lg badge-rounded-circle bg-success">
                        <span>?</span>
                    </div>

                    <div class="ms-5">
                        <h4 class="text-white">
                            {$_("communicate.faq.q3.q")}
                        </h4>

                        <p class="text-muted mb-6 mb-md-8">
                            {$_("communicate.faq.q3.a")}
                        </p>
                    </div>
                </div>

                <div class="d-flex">
                    <div class="badge badge-lg badge-rounded-circle bg-success">
                        <span>?</span>
                    </div>

                    <div class="ms-5">
                        <h4 class="text-white">
                            {$_("communicate.faq.q4.q")}
                        </h4>

                        <p class="text-muted mb-6 mb-md-8">
                            {$_("communicate.faq.q4.a")}
                        </p>
                    </div>
                </div>

                <div class="d-flex">
                    <div class="badge badge-lg badge-rounded-circle bg-success">
                        <span>?</span>
                    </div>

                    <div class="ms-5">
                        <h4 class="text-white">
                            {$_("communicate.faq.q6.q")}
                        </h4>

                        <p class="text-muted mb-6 mb-md-0">
                            {$_("communicate.faq.q6.a")}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
